export default {
  
  en: {
    title: 'Order Management',
    allTitle: 'All Orders',
    loanTitle: 'Disbursed Orders',
    pendingTitle: 'Pending Disbursement Orders',
    overdueTitle: 'Overdue Orders',
    repayReportTitle: 'Repayment Report 1',
    transformingDataExportTitle: 'Conversion Data Export',
    orderNo: 'Order Number',
    orderId: 'Order ID',
    orderType: 'Order Type',
    loanStatus: 'Disbursement Status',
    loanAmount: 'Disbursement Amount',
    loanTime: 'Disbursement Time',
    loanPurpose: 'Loan Purpose',
    loanNumber: 'Loan Count',
    settlementStatus: 'Settlement Status',
    fRate: 'Fee',
    settlementTime: 'Settlement Time',
    overdueStatus: 'Overdue Status',
    applicationTime: 'Application Time',
    applicationAmount: 'Application Amount',
    deadline: 'Term',
    applicationDeadline: 'Application Term',
    submissionTime: 'Submission Time',
    bankAccountNo: 'Receiving Account for Order Disbursement',
    orderDetail: 'Order Details',
    orderInfo: 'Order Information',
    examineCustomerInfo: 'Review Customer Information',
    examineAddressInfo: 'Review Address Information',
    approvalDetail: 'Approval Details',
    collectionDetail: 'Collection Details',
    repaymentPlan: 'Repayment Plan',
    totalPeriod: 'Total Periods',
    currentPeriod: 'Current Period',
    startingTime: 'Start Time',
    expireTime: 'Due Time',
    totalRepayableAmount: 'Total Repayable Amount',
    principalPayable: 'Principal Payable',
    overdueDays: 'Overdue Days',
    forfeitPenalty: 'Late Fee',
    status: 'Status',
    sxCreditScore: 'INX Credit Score',
    sxCheatScore: 'INX Fraud Score',
    overdueDaysStart: 'Overdue Days (From)',
    overdueDaysEnd: 'Overdue Days (To)',

    collectionRecord: 'Collection Record',
    collectionStaff: 'Collector',
    collectionTime: 'Collection Time',
    collectionTaskStatus: 'Collection Task Status',
    collectionStatus: 'Collection Status',
    collectionRemark: 'Remark',
    followUserName: 'Follower',
    followTime: 'Follow-up Time',
    overdueDay: 'Overdue Days',
    followResult: 'Follow-up Result',
    followingUpOrder: 'Orders in Follow-up',
    repaymentIntention: 'Repayment Intention',
    sysMobile: 'Collector Account',

    approvalRecord: 'Approval Record',
    approvalStaff: 'Approver',
    approvalTime: 'Approval Time',
    approvalTaskStatus: 'Approval Task Status',
    approvalStatus: 'Review Status',
    approvalRemark: 'Remark',

    addressBookList: 'Address Book List',
    addressBookName: 'Contact Name',
    addressBookPhoneNo: 'Contact Phone Number',

    lending: 'Disburse',
    isLoan: 'Confirm Disbursement?',
    location: 'Location Address',
    q1: 'Is the borrower\'s phone connected?',

    repaymentRecord: 'Repayment Record',
    payoutRecord: 'Disbursement Record',
    payOrderNo: 'Payment Order No.',
    payOutId: 'Payment Provider Order No.',
    payInId: 'Internal Payment Order No.',
    payType: 'Payment Type',
    payAmount: 'Payment Amount',
    payRecipt: 'Receipt No.',
    description: 'Description',
    errorDescription: 'Failure Description',
    recordTime: 'Record Date',
    updatedTime: 'Update Time',
    channel: 'Channel',
    productName: 'Product Name',
    isSettle: 'Process Offline Repayment?',
    isReductionAmt: 'Apply Late Fee Reduction?',
    isRefuseReductionAmt: 'Reject Late Fee Application?',
    branchType: 'Branch Type',
    curdate: 'Date',
    caseLoanName: 'Loan Supermarket Name',
    regCount: 'Registrations',
    cardCustCount: 'Customers Completed ID Photo',
    faceCount: 'Customers Completed Facial Recognition',
    baseCount: 'Customers Completed Basic Info',
    linkManCount: 'Customers Completed Contact Info',
    applyCount: 'Applications',
    bankCardCount: 'Customers Bound Bank Card',
    approveCount: 'Approvals',
    loanCount: 'Disbursements',
    overdueOrder: 'Overdue Orders',
    overdueSettleOrder: 'Overdue Unsettled Orders',
    custType: 'User Type',

    applyAmt: 'Application Amount',
    repaymentAmount: 'Repayment Amount Due',
    settleAmt: 'Repaid Amount',
    lateFee: 'Late Fee',
    settledLateFee: 'Repaid Late Fee',
    overdueDayC: 'Overdue Days',
    linkCondition: 'Address Book and Contact Status',
    orderNumber: 'User or Recent Contact Phone Number',
    capital: 'Principal Due',
    settledCapital: 'Repaid Principal',
    interest: 'Interest',
    settledInterest: 'Repaid Interest',
    deductionFee: 'Reduction Amount',
    deductionFeeEndDate: 'Reduction Amount Expiry Date',
    hadDeductionFee: 'Amount Already Reduced',

    paymentAmt: 'Actual Disbursement Amount',
    paymentTime: 'Disbursement Time',
    extendAmoumt: 'Extension Amount',
    oxxoCode: 'OXXO Repayment Code',
    extendOxxoCode: 'OXXO Extension Repayment Code',
    registerTime: 'Registration Time',
    appName: 'APP',
    ext: 'Extra Info',
    ext1: 'Extra Info 1',
    serviceFee: 'Service Fee',
    settledServiceFee: 'Repaid Service Fee',
    otherFee: 'Other Fees',
    settledOtherFee: 'Repaid Other Fees',
    handleFee: 'Handling Fee',
    operationUserName: 'Operator Name',
    settledHandleFee: 'Repaid Handling Fee',
    repaymentLink: 'Repayment Link',
    couponAmount: 'Coupon Amount',
    abandonApply: 'Abandon Loan',
    cancelAbandonApply: 'Cancel Abandon Loan',

    newLoanCount: 'New User Loan Count',
    jianjunNew: 'Average Amount for New Users',
    oldLoanCount: 'Returning User Loan Count',
    jianjunOld: 'Average Amount for Returning Users',
    noRate: 'Returning User Ratio',
    paymentAmtReport: 'Loan Principal Disbursed',
    newPaymentAmt: 'Principal Disbursed to New Users',
    oldPaymentAmt: 'Principal Disbursed to Returning Users',
    applyAmtReport: 'Loan Contract Amount',
    newApplyAmt: 'Contract Amount for New Users',
    oldApplyAmt: 'Contract Amount for Returning Users',

    accountCancellation: 'Account Cancellation',

    settlementCertificate: 'Settlement Certificate',
    usedDeductionFee: 'Used Reduction Amount',
    appSsid: 'App Package Name',

    modify_collector: 'Modify Collector',
    at_least_one_required: 'orderNo, mobileNo and orderId cannot all be empty at the same time',
    deduction_amount_required: 'Deduction amount cannot be blank',
    deduction_amount_exceeds_late_fee: 'Deduction amount cannot exceed late fee',
    password_required: 'Verification password cannot be empty',
    confirm_offline_extension: 'Confirm offline extension repayment?',
    confirm_modify_collector: 'Confirm to modify collector?',
    collector_mobile_label: 'Collector mobile phone:',
    completion_status_label: 'Completion status:',
    status_incomplete: 'Incomplete',
    status_completed: 'Completed',
    collection_status_required: 'Collection task status cannot be empty',
    collector_mobile_required: 'Collector mobile phone cannot be empty',
    full_settlement: '(Full)',
    password_label: 'Verification password:',
    payment_link: 'Payment Link',
    late_fee_label: 'Late fee:',
    deduction_amount_label: 'Deduction amount:'
  },
  es: {
    title: 'Quản lý đơn vay',
    allTitle: 'Tất cả đơn vay',
    loanTitle: 'Đơn vay đã giải ngân',
    pendingTitle: 'Đơn vay chờ giải ngân',
    overdueTitle: 'Đơn vay quá hạn',
    repayReportTitle: 'Báo cáo hoàn tiền 1',
    transformingDataExportTitle: 'Xuất dữ liệu chuyển đổi',
    orderNo: 'Mã đơn vay',
    orderId: 'ID đơn vay',
    orderType: 'Loại giao dịch',
    loanStatus: 'Trạng thái giải ngân',
    loanAmount: 'Số tiền giải ngân',
    loanTime: 'Thời gian giải ngân',
    loanPurpose: 'Mục đích vay',
    loanNumber: 'Số lần vay',
    settlementStatus: 'Trạng thái tất toán',
    fRate: 'Phí dịch vụ',
    settlementTime: 'Thời gian tất toán',
    overdueStatus: 'Trạng thái quá hạn',
    applicationTime: 'Thời gian đăng ký vay',
    applicationAmount: 'Số tiền vay',
    deadline: 'Thời hạn',
    applicationDeadline: 'Kỳ hạn đăng ký',
    submissionTime: 'Thời gian gửi',
    bankAccountNo: 'Tài khoản nhận tiền giải ngân',
    orderDetail: 'Chi tiết đơn vay',
    orderInfo: 'Thông tin đơn vay',
    examineCustomerInfo: 'Thẩm định thông tin khách hàng',
    examineAddressInfo: 'Thẩm định thông tin địa chỉ',
    approvalDetail: 'Chi tiết phê duyệt',
    collectionDetail: 'Chi tiết thu hồi nợ',
    repaymentPlan: 'Kế hoạch trả nợ',
    totalPeriod: 'Tổng số kỳ',
    currentPeriod: 'Kỳ hiện tại',
    startingTime: 'Thời gian bắt đầu',
    expireTime: 'Thời gian hết hạn',
    totalRepayableAmount: 'Tổng số tiền phải trả',
    principalPayable: 'Gốc phải trả',
    overdueDays: 'Số ngày quá hạn',
    forfeitPenalty: 'Phí quá hạn',
    status: 'Trạng thái',
    sxCreditScore: 'Điểm tín dụng INX',
    sxCheatScore: 'Điểm gian lận INX',
    overdueDaysStart: 'Số ngày quá hạn (từ)',
    overdueDaysEnd: 'Số ngày quá hạn (đến)',

    collectionRecord: 'Hồ sơ thu hồi nợ',
    collectionStaff: 'Nhân viên thu hồi nợ',
    collectionTime: 'Thời gian thu hồi nợ',
    collectionTaskStatus: 'Trạng thái nhiệm vụ thu hồi nợ',
    collectionStatus: 'Trạng thái thu hồi nợ',
    collectionRemark: 'Ghi chú',
    followUserName: 'Người theo dõi',
    followTime: 'Thời gian theo dõi',
    overdueDay: 'Số ngày quá hạn',
    followResult: 'Kết quả theo dõi',
    followingUpOrder: 'Đơn vay đang theo dõi',
    repaymentIntention: 'Ý muốn trả nợ',
    sysMobile: 'Tài khoản nhân viên thu hồi nợ',

    approvalRecord: 'Hồ sơ phê duyệt',
    approvalStaff: 'Nhân viên phê duyệt',
    approvalTime: 'Thời gian phê duyệt',
    approvalTaskStatus: 'Trạng thái nhiệm vụ phê duyệt',
    approvalStatus: 'Trạng thái thẩm định',
    approvalRemark: 'Ghi chú',

    addressBookList: 'Danh sách danh bạ',
    addressBookName: 'Tên người liên hệ',
    addressBookPhoneNo: 'Số điện thoại người liên hệ',

    lending: 'Giải ngân',
    isLoan: 'Có giải ngân không?',
    location: 'Địa chỉ định vị',
    q1: 'Điện thoại người vay có kết nối không',

    repaymentRecord: 'Hồ sơ trả nợ',
    payoutRecord: 'Hồ sơ giải ngân',
    payOrderNo: 'Mã đơn thanh toán',
    payOutId: 'Mã đơn công ty thanh toán',
    payInId: 'Mã đơn thanh toán nội bộ',
    payType: 'Loại thanh toán',
    payAmount: 'Số tiền thanh toán',
    payRecipt: 'Số hóa đơn',
    description: 'Mô tả',
    errorDescription: 'Mô tả thất bại',
    recordTime: 'Ngày ghi nhận',
    updatedTime: 'Thời gian cập nhật',
    channel: 'Kênh',
    productName: 'Tên sản phẩm',
    isSettle: 'Có thực hiện trả nợ ngoại tuyến không?',
    isReductionAmt: 'Có thực hiện giảm miễn phí quá hạn không?',
    isRefuseReductionAmt: 'Có từ chối đơn xin giảm miễn không?',
    branchType: 'Loại chi nhánh',
    curdate: 'Ngày',
    caseLoanName: 'Tên siêu thị cho vay',
    regCount: 'Số lượng đăng ký',
    cardCustCount: 'Số khách hàng hoàn thành chụp ảnh CMND/CCCD',
    faceCount: 'Số khách hàng nhận diện khuôn mặt',
    baseCount: 'Số khách hàng hoàn thiện thông tin cơ bản',
    linkManCount: 'Số khách hàng hoàn thiện thông tin người liên hệ',
    applyCount: 'Số lượng đơn đăng ký vay',
    bankCardCount: 'Số khách hàng liên kết thẻ ngân hàng',
    approveCount: 'Số lượng thông qua',
    loanCount: 'Số lượng khoản vay đã giải ngân',
    overdueOrder: 'Đơn vay quá hạn',
    overdueSettleOrder: 'Đơn vay quá hạn chưa tất toán',
    custType: 'Loại khách hàng',


    applyAmt: 'Số tiền vay',
    repaymentAmount: 'Số tiền phải trả',
    settleAmt: 'Số tiền đã trả',
    lateFee: 'Phí quá hạn',
    settledLateFee: 'Phí quá hạn đã trả',
    overdueDayC: 'Số ngày quá hạn',
    linkCondition: 'Tình trạng danh bạ và người liên hệ',
    orderNumber: 'Mã đơn vay',
    capital: 'Gốc phải trả',
    settledCapital: 'Gốc đã trả',
    interest: 'Tiền lãi',
    settledInterest: 'Tiền lãi đã trả',
    // lateFee: 'Phí quá hạn',
    deductionFee: 'Số tiền giảm miễn',
    deductionFeeEndDate: 'Thời hạn giảm miễn',
    hadDeductionFee: 'Số tiền đã giảm miễn',

    paymentAmt: 'Số tiền thực nhận',
    paymentTime: 'Thời gian giải ngân',
    extendAmoumt: 'Số tiền gia hạn',
    oxxoCode: 'Mã thanh toán OXXO',
    extendOxxoCode: 'Mã thanh toán gia hạn OXXO',
    registerTime: 'Thời gian đăng ký',
    appName: 'Ứng dụng',
    ext: 'Thông tin thêm',
    ext1: 'Thông tin thêm 1',
    serviceFee: 'Phí dịch vụ',
    settledServiceFee: 'Phí dịch vụ đã trả',
    otherFee: 'Phí khác',
    settledOtherFee: 'Phí khác đã trả',
    handleFee: 'Phí xử lý',
    operationUserName: 'Tên người thao tác',
    settledHandleFee: 'Phí xử lý đã trả',
    repaymentLink: 'Link trả nợ',
    couponAmount: 'Số tiền mã giảm giá',
    abandonApply: 'Hủy đơn đăng ký',
    cancelAbandonApply: 'Hủy bỏ việc hủy đơn đăng ký',

    newLoanCount: 'Số khoản vay của khách hàng mới',
    jianjunNew: 'Giá trị trung bình mỗi khoản vay của khách hàng mới',
    oldLoanCount: 'Số khoản vay của khách hàng cũ',
    jianjunOld: 'Giá trị trung bình mỗi khoản vay của khách hàng cũ',
    noRate: 'Tỷ trọng khách hàng cũ',
    paymentAmtReport: 'Tổng số tiền giải ngân',
    newPaymentAmt: 'Tổng tiền giải ngân cho khách hàng mới',
    oldPaymentAmt: 'Tổng tiền giải ngân cho khách hàng cũ',
    applyAmtReport: 'Tổng giá trị hợp đồng vay',
    newApplyAmt: 'Giá trị hợp đồng vay của khách hàng mới',
    oldApplyAmt: 'Giá trị hợp đồng vay của khách hàng cũ',

    accountCancellation: 'Hủy tài khoản',

    settlementCertificate: 'Chứng nhận tất toán',
    usedDeductionFee: 'Số tiền giảm miễn đã sử dụng',
    appSsid: 'Mã appssid',

    modify_collector: 'Thay đổi nhân viên thu hồi nợ',
    at_least_one_required: 'orderNo, mobileNo và orderId không được để trống cùng lúc',
    deduction_amount_required: 'Số tiền giảm miễn không được để trống',
    deduction_amount_exceeds_late_fee: 'Số tiền giảm miễn không được lớn hơn phí quá hạn',
    password_required: 'Mật khẩu xác thực không được để trống',
    confirm_offline_extension: 'Xác nhận gia hạn trả nợ offline?',
    confirm_modify_collector: 'Xác nhận thay đổi nhân viên thu hồi nợ?',
    collector_mobile_label: 'Số điện thoại nhân viên thu hồi nợ:',
    completion_status_label: 'Trạng thái hoàn thành:',
    status_incomplete: 'Chưa hoàn thành',
    status_completed: 'Đã hoàn thành',
    collection_status_required: 'Trạng thái nhiệm vụ thu hồi không được để trống',
    collector_mobile_required: 'Số điện thoại nhân viên thu hồi nợ không được để trống',
    full_settlement: '(Toàn bộ)',
    password_label: 'Xác thực mật khẩu:',
    payment_link: 'Liên kết thanh toán',
    late_fee_label: 'Phí quá hạn:',
    deduction_amount_label: 'Số tiền giảm miễn:'

  },
}
